/** AI Dashboards walkthrough (YouTube embed). Shared by chat sidebar and nav help menu. */
export const AI_DASHBOARDS_VIDEO_CARD_DISMISSED_KEY = "webDashboardAiDashboardsVideoCardDismissed";

/** Promo thumbnail (nav help menu + chat sidebar). */
export const AI_DASHBOARDS_VIDEO_THUMBNAIL_SRC = "/static/ai-dashboards-video-thumbnail.png";

/** Omit autoplay so playback starts from a click inside the player and audio is allowed (iframe autoplay is usually muted). */
export const AI_DASHBOARDS_GSHEETS_HELP_VIDEO_URL =
  "https://www.youtube-nocookie.com/embed/w21NdgVtC6E?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&fs=0&disablekb=1&playsinline=1&cc_load_policy=0";

export const AI_DASHBOARDS_EXCEL_HELP_VIDEO_URL =
  "https://www.youtube-nocookie.com/embed/9UNLy1g6Ha0?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3&fs=0&disablekb=1&playsinline=1&cc_load_policy=0";

// Backward-compatible default for existing call sites (GSheets).
export const AI_DASHBOARDS_HELP_VIDEO_URL = AI_DASHBOARDS_GSHEETS_HELP_VIDEO_URL;

export const getAiDashboardsHelpVideoUrl = (sourceType?: string | null): string =>
  sourceType === "excel"
    ? AI_DASHBOARDS_EXCEL_HELP_VIDEO_URL
    : AI_DASHBOARDS_GSHEETS_HELP_VIDEO_URL;
export const AI_DASHBOARDS_VIDEO_MODAL_WIDTH = 1040;
export const AI_DASHBOARDS_VIDEO_MODAL_HEIGHT = 585;
